"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTransferArgs = exports.transferArgs = exports.getTransferArgsSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const _1 = require(".");
function getTransferArgsSerializer() {
    return (0, serializers_1.dataEnum)([
        [
            'V1',
            (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
                ['amount', (0, serializers_1.u64)()],
                ['authorizationData', (0, serializers_1.option)((0, _1.getAuthorizationDataSerializer)())],
            ]), (value) => ({
                ...value,
                amount: value.amount ?? 1,
                authorizationData: value.authorizationData ?? (0, umi_1.none)(),
            })),
        ],
    ], { description: 'TransferArgs' });
}
exports.getTransferArgsSerializer = getTransferArgsSerializer;
function transferArgs(kind, data) {
    return Array.isArray(data)
        ? { __kind: kind, fields: data }
        : { __kind: kind, ...(data ?? {}) };
}
exports.transferArgs = transferArgs;
function isTransferArgs(kind, value) {
    return value.__kind === kind;
}
exports.isTransferArgs = isTransferArgs;
//# sourceMappingURL=transferArgs.js.map